<template>
  <div
    v-if="showModal"
    class="modalOverlay tw-fixed tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-backdrop-blur-sm"
  >
    <div
      class="tw-bg-white/95 tw-px-4 tw-py-3 tw-flex tw-flex-col tw-gap-1.5 tw-rounded-xl tw-text-center tw-w-56 tw-shadow-2xl tw-border tw-border-gray-100"
    >
      <span class="tw-text-sm tw-font-semibold tw-text-gray-800">
        {{ titleText }}
      </span>
      <p class="tw-text-xs tw-text-gray-500 tw-leading-tight"> {{ subtitleText }} </p>
      <div class="tw-flex tw-flex-col tw-gap-1.5 tw-mt-1">
        <button
          class="checkoutButton tw-bg-solYellow tw-border-none tw-text-textDark tw-font-semibold tw-rounded-lg tw-text-xs tw-w-full tw-py-2 tw-cursor-pointer tw-flex tw-justify-center tw-items-center hover:tw-bg-solYellowHover tw-transition-all hover:tw-scale-[1.02]"
          @click="onConfirm"
        >
          {{ buttonConfirmText }}
          <img
            :src="getAssetPath('/assets/images/next.svg')"
            :alt="$t('confirm')"
            class="tw-ml-1 tw-w-3 tw-h-3"
          />
        </button>
        <button
          class="tw-bg-gray-100 tw-border tw-border-gray-200 tw-text-gray-700 tw-rounded-lg tw-text-xs tw-w-full tw-py-2 tw-cursor-pointer tw-flex tw-justify-center tw-items-center hover:tw-bg-gray-200 tw-transition-all hover:tw-scale-[1.02]"
          @click="onClose"
        >
          {{ buttonCloseText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAssetPath } from '@/utils/assetPath';
import { trackEvent } from '@/utils/tracking';

export default {
  setup() {
    return {
      getAssetPath
    };
  },
  data() {
    return {
      showModal: false,
      state: null,
    };
  },
  props: {
    buttonConfirmText: {
      type: String,
    },
    buttonCloseText: {
      type: String,
    },
    titleText: {
      type: String,
    },
    subtitleText: {
      type: String,
    }
  },
  methods: {
    open(state) {
      this.showModal = true;
      this.state = state
    },
    close(success = true) {
      this.showModal = false;
      this.$emit("onModalClosed", {success, state: this.state });
    },
    onConfirm() {
      trackEvent({
        eventName: "Customizer",
        eventType: "Click",
        action: "ModalButtonConfirm",
        details: { modal: "PromptModal" },
      });
      this.close(true);
    },
    onClose() {
      trackEvent({
        eventName: "Customizer",
        eventType: "Click",
        action: "CloseModal",
        details: { modal: "PromptModal" },
      });
      this.close(false);
    },
  },
};
</script>

<style lang="scss" scoped>
#cardDesigner {
  .modalOverlay {
    z-index: 11;
    background: linear-gradient(135deg, rgba(255, 239, 70, 0.15) 0%, rgba(147, 51, 234, 0.15) 100%);
    animation: fadeIn 0.2s ease-out;

    button,
    button:hover {
      background: var(--color-bg-light) !important;
    }

    .checkoutButton,
    .checkoutButton:hover {
      background: var(--color-sol-yellow) !important;
    }

    > div {
      animation: slideUp 0.3s ease-out;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
</style>
